export const initialStatePageKey = 'checkout';
export const CHECKOUT_PAGE_KEY = 'checkout';
export const AMPLITUDE_PAGE_NAME = 'Checkout';
